export default __webpack_public_path__ + "static/media/4 Advantages - Social.7b3182f7.png";